// Centralized API base URL helper.
//
// Local development: REACT_APP_API_URL is unset/blank, so apiUrl() returns
// relative paths (e.g. "/api/auth"), which are handled by the CRA dev-server
// proxy in client/package.json ("proxy": "http://localhost:5001").
//
// Production (Netlify): set REACT_APP_API_URL to the Render backend URL,
// e.g. REACT_APP_API_URL=https://vactrac-api.onrender.com
// so requests are sent directly to the deployed backend.
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const apiUrl = (path) => `${API_BASE_URL}${path}`;

export default apiUrl;
